// Generated by purs version 0.15.15
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Functor_Contravariant_Compat from "../Data.Functor.Contravariant.Compat/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Effect from "../Effect/index.js";
import * as Specular_Callback from "../Specular.Callback/index.js";
import * as Specular_Dom_Builder from "../Specular.Dom.Builder/index.js";
import * as Specular_Dom_Element from "../Specular.Dom.Element/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
import * as Specular_FRP_Replaceable from "../Specular.FRP.Replaceable/index.js";
var whenD = /* #__PURE__ */ Specular_FRP_Replaceable.whenD(/* #__PURE__ */ Specular_FRP_Base.monadFRP(Specular_Dom_Builder.monadEffectBuilder)(Specular_Dom_Builder.monadCleanupBuilder))(Specular_Dom_Builder.monadReplaceBuilder);
var map = /* #__PURE__ */ Data_Functor.map(Specular_FRP_Base.functorDynamic);
var append = /* #__PURE__ */ Data_Semigroup.append(/* #__PURE__ */ Data_Semigroup.semigroupFn(/* #__PURE__ */ Effect.semigroupEffect(Data_Semigroup.semigroupUnit)));
var contramapCallbackDynMaybe = /* #__PURE__ */ Specular_Callback.contramapCallbackDynMaybe();
var whenNothingD = function (dyn) {
    return function (content) {
        return whenD(map(Data_Maybe.isNothing)(dyn))(content);
    };
};
var onTouchStart = function (cb) {
    return Specular_Dom_Element.on("touchstart")(cb);
};
var onTouchStartPreventDefault = /* #__PURE__ */ onTouchStart(Specular_Dom_Element.preventDefault);
var onTouchMove = function (cb) {
    return Specular_Dom_Element.on("touchmove")(cb);
};
var onTouchMovePreventDefault = /* #__PURE__ */ onTouchMove(Specular_Dom_Element.preventDefault);
var onSubmitPreventDefault_ = function (cb) {
    return Specular_Dom_Element.on("submit")(append(Specular_Dom_Element.preventDefault)(Data_Functor_Contravariant_Compat.cvoid(cb)));
};
var onClickPreventDefault_ = function (cb) {
    return Specular_Dom_Element.onClick(append(Specular_Dom_Element.preventDefault)(Data_Functor_Contravariant_Compat.cvoid(cb)));
};
var gateEvent = function (dyn) {
    return function (event) {
        return Specular_FRP_Base.filterJustEvent(Specular_FRP_Base.attachDynWith(function (dynValue) {
            return function (evt) {
                if (dynValue) {
                    return new Data_Maybe.Just(evt);
                };
                return Data_Maybe.Nothing.value;
            };
        })(dyn)(event));
    };
};
var gateCallback = function (dyn) {
    return function (cb) {
        return contramapCallbackDynMaybe(map(function (v) {
            if (v) {
                return Data_Maybe.Just.create;
            };
            return Data_Function["const"](Data_Maybe.Nothing.value);
        })(dyn))(cb);
    };
};
export {
    whenNothingD,
    onClickPreventDefault_,
    gateEvent,
    gateCallback,
    onSubmitPreventDefault_,
    onTouchStart,
    onTouchStartPreventDefault,
    onTouchMove,
    onTouchMovePreventDefault
};
